import { useEffect } from "react";

function ContactFromEvent() {
  useEffect(() => {
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "conversion", {
        send_to: "AW-11159481698/S_mICIjTqYsbEOLaoMkp",
      });
    }
  }, []);

  return (
    <div>
      {/* Your page content */}
    </div>
  );
}

export default ContactFromEvent;